var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.5C1.22386 2.5 1 2.72386 1 3C1 3.27614 1.22386 3.5 1.5 3.5H1.505C1.78114 3.5 2.005 3.27614 2.005 3C2.005 2.72386 1.78114 2.5 1.505 2.5H1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5C3.72386 2.5 3.5 2.72386 3.5 3C3.5 3.27614 3.72386 3.5 4 3.5H10.5C10.7761 3.5 11 3.27614 11 3C11 2.72386 10.7761 2.5 10.5 2.5H4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5C3.72386 5.5 3.5 5.72386 3.5 6C3.5 6.27614 3.72386 6.5 4 6.5H10.5C10.7761 6.5 11 6.27614 11 6C11 5.72386 10.7761 5.5 10.5 5.5H4Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9C3.5 8.72386 3.72386 8.5 4 8.5H10.5C10.7761 8.5 11 8.72386 11 9C11 9.27614 10.7761 9.5 10.5 9.5H4C3.72386 9.5 3.5 9.27614 3.5 9Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6C1 5.72386 1.22386 5.5 1.5 5.5H1.505C1.78114 5.5 2.005 5.72386 2.005 6C2.005 6.27614 1.78114 6.5 1.505 6.5H1.5C1.22386 6.5 1 6.27614 1 6Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.5C1.22386 8.5 1 8.72386 1 9C1 9.27614 1.22386 9.5 1.5 9.5H1.505C1.78114 9.5 2.005 9.27614 2.005 9C2.005 8.72386 1.78114 8.5 1.505 8.5H1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorList);
export default __webpack_public_path__ + "static/media/editor-list.364d0c103d1bc3e8acd169444bad6547.svg";
export { ForwardRef as ReactComponent };